import React from 'react';
import { IconButton, IconButtonSize, IconButtonTheme } from '@apply/components';
import { faPenToSquare, faTrashCan } from '@fortawesome/free-solid-svg-icons';
import { OrgChartNode } from '../types';

interface OrgChartProps {
    root: OrgChartNode;
    onEdit?: (node: OrgChartNode) => void;
    onDelete?: (node: OrgChartNode) => void;
}

interface NodeProps {
    node: OrgChartNode;
    onEdit?: (node: OrgChartNode) => void;
    onDelete?: (node: OrgChartNode) => void;
}

const OrgChartNodeView: React.FC<NodeProps> = ({ node, onEdit, onDelete }) => (
    <li className='bp-orgChart__node'>
        <div className='bp-orgChart__box'>
            {node.ownershipPercent !== null && (
                <div className='bp-orgChart__percent'>{node.ownershipPercent}% Ownership</div>
            )}
            <div className='bp-orgChart__label'>{node.label}</div>

            <div className='bp-orgChart__actions'>
                {node.canEdit && onEdit && (
                    <IconButton
                        id={`bpOrgChartEdit_${node.key}`}
                        icon={faPenToSquare}
                        theme={IconButtonTheme.Transparent}
                        size={IconButtonSize.Small}
                        hint='Edit'
                        handleClick={() => onEdit(node)}
                    />
                )}
                {node.canDelete && onDelete && (
                    <IconButton
                        id={`bpOrgChartDelete_${node.key}`}
                        icon={faTrashCan}
                        theme={IconButtonTheme.TransparentRed}
                        size={IconButtonSize.Small}
                        hint='Delete'
                        handleClick={() => onDelete(node)}
                    />
                )}
            </div>
        </div>

        {node.children.length > 0 && (
            <ul className='bp-orgChart__children'>
                {node.children.map((child) => (
                    <OrgChartNodeView
                        key={child.key}
                        node={child}
                        onEdit={onEdit}
                        onDelete={onDelete}
                    />
                ))}
            </ul>
        )}
    </li>
);

export const OrgChart: React.FC<OrgChartProps> = ({ root, onEdit, onDelete }) => (
    <div className='bp-orgChart'>
        <ul className='bp-orgChart__root'>
            <OrgChartNodeView
                node={root}
                onEdit={onEdit}
                onDelete={onDelete}
            />
        </ul>
    </div>
);
